import React from "react";
import Rollbar from '../../utils/RollbarTracking'
import axios from 'axios'
import { toast } from 'react-toastify';

import {SettingsNav} from '../../components/SettingsNav'

export class SettingsPassword extends React.Component {

  constructor(props)  {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  state = {
    oldPassword: '',
    password1: '',
    password2: ''
  }

  handleChange (evt) {
    this.setState({ [evt.target.name]: evt.target.value });
  }

  updatePassword = async () => {
    if (this.state.password1 === this.state.password2) {
      if (this.state.password1 === this.state.oldPassword) {
        toast.error("New password must be different than old password");
      }
      else {
        let requestParams = {
          'password': this.state.password1,
        }
        axios.post('/user/update/password', requestParams)
          .then(data => {
            console.log(data);
            toast.success('Password changed!')
          })
          .catch(err => {
            console.log(err)
            Rollbar.error(err)
          })
      }
    }
    else {
      toast.error("Passwords do not match");
    }
  }

    render() {
        return (
            <div className="mar-bot-lg">
              <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-1 mb-3 border-bottom">
                <h1 className="h3">Settings</h1>
              </div>
              <div className="row">
                <div className="col-md-2 col-sm-12">
                  <SettingsNav/>
                </div>
                <div className="col-md-10 col-sm-12">
                  <div className="card">
                    <div className="card-header">
                      Change Password
                    </div>
                    <div className="card-body">
                      <div className="form-group">
                        <label>Old Password:</label>
                        <input type="password" className="form-control" value={this.state.oldPassword} onChange={this.handleChange} name="oldPassword" />
                      </div>
                      <div className="form-row">
                        <div className="form-group col-md-6">
                          <label>New Password:</label>
                          <input type="password" className="form-control" value={this.state.password1} onChange={this.handleChange} name="password1" />
                        </div>
                        <div className="form-group col-md-6">
                          <label>Confirm New Password:</label>
                          <input type="password" className="form-control" value={this.state.password2} onChange={this.handleChange} name="password2" />
                        </div>
                      </div>
                      <button type="button" onClick={this.updatePassword} className="btn btn-success btn-block">Change Password</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        );
    }
}
